/**
 * @file 404页面
 * @author wangzhuang
 * */

import React, {Component} from 'react';

import './index.less';

export default class Redirect extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div className={'redirect'}>
                <div className={'redirect-icon'}>
                    <img src={require('../../asset/image/redirect/pic_404.svg')} alt=""/>
                </div>
                <div className={'redirect-con'}>
                    <div>
                        啊哦，没有找到这个页面/(ToT)/～～
                    </div>
                    <a href="/m/">
                        返回百度安全首页
                    </a>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/redirect/index.js